export default __webpack_public_path__ + "static/media/pagebanner4.ef8cb722.jpg";